import { Controller } from "@hotwired/stimulus"

// Handles automatic redirect after successful AI build completion.
// Used by Turbo Stream broadcasts from background jobs.
export default class extends Controller {
  static values = {
    url: String,
    message: String
  }

  connect() {
    // Redirect after a short delay to let user see the success message
    this.timeout = setTimeout(() => {
      window.location.href = this.urlValue
    }, 1500)
  }

  disconnect() {
    if (this.timeout) {
      clearTimeout(this.timeout)
    }
  }
}
